<template>
  <div
    :class="{
      'opacity-50 cursor-not-allowed':
        inProgress ||
        (ecosystemApp &&
          ecosystemApp.application &&
          ecosystemApp.application.status != '0' &&
          ecosystemApp.application.status != '2')
    }"
  >
    <h2 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b">
      Informations
    </h2>
    <div
      v-if="isSubmitted && errors == null"
      class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.submitted") }}</strong>
      </p>
    </div>
    <div
      v-if="errors.length"
      class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4"
      role="alert"
    >
      <p class="mb-0">
        <strong class="font-bold">{{ $t("form.infinsh") }}</strong>
      </p>
    </div>
    <form
      autocomplete="off"
      name="teamEdit"
      v-on:submit.prevent="submitInvestor()"
    >
      <div class="flex my-8 max-w-md">
        <div class="flex-1 px-4 py-2">
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('name')"
            >{{
              getFieldMsgError("name") ||
                $t("team.name") + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('name') ? 'has-error input' : ''"
            theme="team"
            name="name"
            v-model="form.name"
            :label="'Raison sociale'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="
              validateFieldError('legal_representative')"
            >{{
              getFieldMsgError("legal_representative") ||
                "Le représentant légal" + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('legal_representative') ? 'has-error input' : ''"
            theme="team"
            name="legal_representative"
            v-model="form.legal_representative"
            :label="'Le représentant légal'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            v-if="validateFieldError('country')"
            class="text-sm block sm:inline text-left text-red-dark py-3"
          >
            {{
              getFieldMsgError('country') == "Pays est obligatoire" ? "Gouvernorat est obligatoire" : "" ||
              "Gouvernorat " + " " + $t("form.required")
            }}
          </span>
          <span
            v-if="validateFieldError('city') && !validateFieldError('country')"
            class="text-sm block sm:inline text-left text-red-dark py-3"
          >
            {{
              getFieldMsgError('city') == "city est obligatoire" ? "Délégation est obligatoire" : ""||
              "Délégation " + " " + $t("form.required")
            }}
          </span>
          <sp-code-postal-list
            class="mt-3"
            @select-change="delegationChange" 
            :selectedgovernorate="form.country" 
            :selecteddelegation="form.city"
            :selectedcodePostal="form.postal_code"
            :govError="validateFieldError('country') ? true : false"
            :delError="validateFieldError('city') ? true : false"
            :edited="edit" 
            @edit-change-deleg="editChangeDel"
            @code-postal="handleCodePostal">
          </sp-code-postal-list>
          <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('adress')"
              >{{
                getFieldMsgError("adress") ||
                  "Adresse" + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="validateFieldError('adress') ? 'has-error input' : ''"
              theme="team"
              name="adress"
              v-model="form.adress"
              :label="'Adresse'"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-input>
          <!-- ########### -->
          <div class="flex flex-row">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('unique_identifier')"
            >
              {{ getFieldMsgError("unique_identifier") == "Le format du champ Identifiant unique est invalide" ? $t("form.invalid_unique_identifier") : getFieldMsgError("unique_identifier")
              || "Identifiant unique" + " " + $t("form.required") }}
            </span>
          </div>

          <sp-input
            class="mt-3"
            :class="validateFieldError('unique_identifier') ? 'has-error input' : ''"
            theme="team"
            name="unique_identifier"
            v-model="form.unique_identifier"
            :label="'Identifiant unique'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('legal_status')"
            >{{
              getFieldMsgError("legal_status") ||
                "Forme juridique" + " " + $t("form.required")
            }}</span
          >
          <sp-select
            class="mt-3 mb-5"
            :class="validateFieldError('legal_status') ? 'has-error input' : ''"
            theme="team"
            name="legal_status"
            v-model="form.legal_status"
            :label="'Forme juridique'"
            :required="true"
            :disabled="
              ecosystemApp &&
              ecosystemApp.application &&
              ecosystemApp.application.status != '0' &&
              ecosystemApp.application.status != '2'
            "
            :options="options"
            :selected="form.legal_status ? form.legal_status : ''"
            placeholder="Sélectionnez option"
          >
            
          </sp-select>

          <sp-input
            class="mt-3"
            v-if="form.legal_status === 'Autres'"
            :class="!form.other_head_office ? 'has-error input' : ''"
            theme="team"
            name="other_head_office"
            v-model="form.other_head_office"
            :label="'Autres'"
            :required="true"
            :disabled="
              ecosystemApp &&
              ecosystemApp.application &&
              ecosystemApp.application.status != '0' &&
              ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            v-if="validateFieldError('share_capital')"
            class="text-sm block sm:inline text-left text-red-dark py-3"
          >
            {{
              getFieldMsgError("share_capital") == "Le format du champ Capital social est invalide" ?  $t("form.invalid_share_capital") : getFieldMsgError("share_capital") ||
              "Capital social" + " " + $t("form.required")
            }}
          </span>
          <sp-input
            class="mt-3"
            :class="validateFieldError('share_capital') ? 'has-error input' : ''"
            theme="team"
            name="share_capital"
            v-model="form.share_capital"
            :label="'Capital social'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('phone')"
            >{{ "Tél" + " " + $t("form.required") }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('phone') ? 'has-error input' : ''"
            theme="team"
            name="phone"
            v-model="form.phone"
            :label="'Tél'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('email')"
            >{{
              getFieldMsgError("email") ||
                "Adresse électronique" + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('email') ? 'has-error input' : ''"
            theme="team"
            name="email"
            v-model="form.email"
            :label="'Adresse électronique'"
            :required="true"
            :disabled="
              ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2'
            "
          ></sp-input>
        </div>
      </div>
      <div
        class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button
          theme="outline-blue"
          space="small"
          :disabled="
            inProgress ||
              (ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2')
          "
          type="submit"
          >{{ $t("team.save") }}</sp-button
        >
        <sp-button
          v-if="this.$route.params.ecoAppId"
          theme="blue"
          space="small"
          type="submit"
          name="next"
          :disabled="
            inProgress ||
              (ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2')
          "
          @click="next()"
          >{{ $t("form.nextTeam") }}
        </sp-button>
      </div>
    </form>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import DropZoneVue from "../../components/spKit/DropZone.vue";
import InputVue from "../../components/spKit/Input.vue";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import Link from "@/components/spKit/Link.vue";
import flatPickr from "vue-flatpickr-component";
import Select from "@/components/spKit/Select.vue";
import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapState } from "vuex";

import { API_URL } from "@/common/config";
import CheckboxVue from "../../components/spKit/Checkbox.vue";
import { SAVE_INVESTOR_FORM, CREATE_ECOSYSTEM_APP } from "@/store/actions.type";
import SelectCountryVue from "../../components/spKit/selectCountry/SelectCountry.vue";
import RadioVue from "../../components/spKit/Radio.vue";
import CodePostalListVue from '../../components/spKit/code-postaux-list.vue';

export default {
  name: "FundMoral",
  props: {
    type: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: false
    },
    application: {
      type: Object,
      required: false
    },
    edit:{
      required:false,
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider,
    "sp-dropzone": DropZoneVue,
    "sp-input": InputVue,
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-link": Link,
    "flat-picker": flatPickr,
    "sp-checkbox": CheckboxVue,
    "sp-select-country": SelectCountryVue,
    "sp-select": Select,
    "sp-radio": RadioVue,
    "sp-code-postal-list": CodePostalListVue,
  },
  data() {
    return {
      inProgress: false,
      isSubmitted: false,
      invalidfield: "",
      errors: [],
      teamErrors: [],
      form: {
        name: null,
        email: null,
        legal_representative: null,
        head_office: null,
        unique_identifier: null,
        legal_status: null,
        share_capital: null,
        phone: null,
        type: this.type,
        other_head_office: null,
        country: null,
        city: null,
        postal_code: null,
        adress: null
      },
      isCreated: false,
      app: {},
      options:[],
    };
  },
  async mounted() {},
  methods: {
    editChange(val){
      this.$emit("edit-change",val);
    },
    editChangeDel(val){
      this.$emit("edit-change",val);
    },
    handleCodePostal(val){
      this.form.postal_code = val[1];
    },
    delegationChange(val) {
      switch (val[0]) {
        case 'governorate':
          this.form.country = val[1];
          this.form.city = null;
          break;
        case 'delegation':
          this.form.city = val[1]; 
          break;
        case 'codePostal':
          this.form.postal_code = val[1]; 
          break;
      }
    },
    submitInvestor() {
      window.scrollTo(0, 0);
      this.$Progress.start();
      this.inProgress = true;
      this.form.type = this.type;
      window.scrollTo(0, 0);
      this.$store
        .dispatch(SAVE_INVESTOR_FORM, {
          data: this.form
        })
        .then((data) => {
          //Here where we must create INVESTOR application if not exist
          if(!this.ecosystemApp.application) {
            return this.createApp("investor");
          } else {
            this.$router.push({
              name: 'sessionlessDeclaration',
              params: {
                app_id:  this.ecosystemApp.application ? this.ecosystemApp.application.hash_id : this.$route.params.ecoAppId,
                appType: this.ecosystemApp.application ? this.ecosystemApp.application.type.toLowerCase() : this.$route.params.appType.toLowerCase()
              }
            });
          }
        })
        .catch(({ response }) => {
          this.$Progress.fail();
          this.inProgress = false;
          if (response) this.errors = response.data.meta.errors;
        });
    },
    createApp(type) {
      if (!this.isCreated) {
        let self = this;
        this.isCreated = true;
        this.$store
          .dispatch(CREATE_ECOSYSTEM_APP, type)
          .then(data => {
            localStorage.setItem("ecosystem", true);
            this.$router.push({
              name: 'sessionlessDeclaration',
              params: {
                app_id:  data.data.application.hash_id || data.data.application.id,
                appType: data.data.application.type.toLowerCase()
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    formatRouteName(route) {
      let blocks = route.split("-");
      blocks.forEach(function callback(element, index) {
        blocks[index] = element.charAt(0).toUpperCase() + element.slice(1);
      });
      return blocks.join("");
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateFieldError(field) {
      const fieldHasError = this.errors.map(e => e.fields[0]).includes(field);
      return fieldHasError;
    },
    getFieldMsgError(field) {
      const errorMsg = this.errors.filter(e => e.fields[0] === field);
      if (errorMsg.length) {
        let res = Array.isArray(errorMsg[0].message)
          ? errorMsg[0].message[0]
          : errorMsg[0].message;
        res =
          res == "Le champ cin number doit contenir 8 chiffres."
            ? "Le champ Cin doit contenir 8 chiffres."
            : res;
          res = res.replace('Email','Adresse électronique');
        return res;
      }
      return "";
    },
    fromDateGreaterThanToDate(dataSource) {
      return (
        dataSource.to_year &&
        !dataSource.currently_work &&
        dataSource.from_year &&
        new Date(dataSource.from_year) > new Date(dataSource.to_year)
      );
    },
    next() {
      console.log(this.$route.params.ecoAppId);
      this.$router.push({
        name: "sessionlessDeclaration",
        params: {
          app_id: this.ecosystemApp.application ? this.ecosystemApp.application.hash_id : this.$route.params.ecoAppId,
          appType: this.ecosystemApp.application ? this.ecosystemApp.application.type.toLowerCase() : this.$route.params.appType.toLowerCase()
        }
      });
    }
  },
  created() {
    if (this.formData) {
      this.form = this.formData;
    }
    if(this.application){
      this.app = this.application
    }
    this.options = [
      {
        default:"0",
        name:"SA",
        value:"SA"
      },
      {
        default:"0",
        name:"SARL",
        value:"SARL"
      },
      {
        default:"0",
        name:"SUARL",
        value:"SUARL"
      },
      {
        default:"0",
        name:"SCA",
        value:"SCA"
      },
      {
        default:"0",
        name:"Autres",
        value:"Autres"
      }
    ];
  },
  computed: {
    ...mapGetters(["session", "currentUser", "ecosystemApp"]),
    isUniqueIdentifierValid() {
      const regex = /^\d{7}[A-NP-Za-np-z]$/; // Regex to match seven digits followed by an alphabetic letter, excluding the letters O, U, and I.
      return regex.test(this.form.unique_identifier);
    },
    isShareCapitalValid() {
      const regex = /^\d{0,10}(?:[.,]\d{1,3})?$/; // Regex to match 7 digits followed by any single character
      return regex.test(this.form.share_capital);
    },
  },
  watch: {
    formData() {
      this.form = this.formData;
    },
    application() {
      this.app = this.application
    }
  },
  beforeDestroy() {}
};
</script>
